import React from 'react';
import PaymentAccountDetails from '../stripe/PaymentAccountDetails';
// import { useAuthState } from '../../contexts/authcontext';

interface StripeIntegrationProps {
  communityId: string;
  userId: string;
  onClose?: () => void;
}

const StripeIntegration: React.FC<StripeIntegrationProps> = ({ 
  communityId, 
  userId, 
  onClose 
}) => {
  return (
    <div className="w-full">
      <PaymentAccountDetails 
        communityId={communityId} 
        userId={userId} 
        onClose={onClose}
        enableExternalAccountCollection={true}
        disableStripeUserAuthentication={false}
      />
    </div>
  );
};

export default StripeIntegration;

